import { MapPin, Phone, MessageCircle, Clock, Check } from "lucide-react";
import { BRANCHES, telLink, waLink } from "../../lib/constants";

const BranchCard = ({ b, idx }) => (
  <div
    id={`branch-${b.id}`}
    data-testid={`branch-card-${b.id}`}
    className="relative bg-[#1A1A1A] border border-white/5 rounded-sm overflow-hidden hover:border-[#FACC15]/40 transition-all"
  >
    <div className="relative h-56 md:h-64 bg-[#211E1A] overflow-hidden">
      <iframe
        title={`${b.name} map`}
        src={b.mapsEmbed}
        className="w-full h-full"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>

    <div className="p-7 md:p-9">
      <h3 className="font-display text-2xl md:text-3xl font-semibold text-white tracking-tight mb-3">
        {b.title}
      </h3>

      <div className="flex items-center gap-2 text-sm text-[#FACC15] mb-2 font-semibold">
        <Clock className="w-4 h-4" />
        <span>{b.timing}</span>
      </div>

      <div className="flex items-start gap-2 text-sm text-white/60 mb-6 leading-relaxed">
        <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
        <span>{b.address}</span>
      </div>

      <div className="border-t border-white/5 pt-6">
        <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4 font-semibold">
          Facilities
        </div>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-7">
          {b.features.map((f) => (
            <li key={f} className="flex items-start gap-2 text-sm text-white/80">
              <Check className="w-4 h-4 text-[#FACC15] mt-0.5 flex-shrink-0" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex flex-wrap gap-2.5">
        <a
          href={b.mapsLink}
          target="_blank"
          rel="noreferrer"
          data-testid={`branch-${b.id}-directions`}
          className="inline-flex items-center gap-2 bg-white text-[#0F0F0F] font-semibold px-4 py-2.5 text-sm rounded-sm hover:-translate-y-0.5 transition-transform"
        >
          <MapPin className="w-4 h-4" /> Get Directions
        </a>
        <a
          href={telLink}
          data-testid={`branch-${b.id}-call`}
          className="inline-flex items-center gap-2 bg-[#FACC15] text-[#0F0F0F] font-semibold px-4 py-2.5 text-sm rounded-sm hover:-translate-y-0.5 transition-transform"
        >
          <Phone className="w-4 h-4" /> Call Now
        </a>
        <a
          href={waLink(`Hi! I'm interested in ${b.name} branch.`)}
          target="_blank"
          rel="noreferrer"
          data-testid={`branch-${b.id}-whatsapp`}
          className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold px-4 py-2.5 text-sm rounded-sm hover:-translate-y-0.5 transition-transform"
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
      </div>
    </div>
  </div>
);

export default function Branches() {
  return (
    <section
      id="branches"
      data-testid="branches-section"
      className="relative py-24 md:py-32 bg-[#0F0F0F]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-[#FACC15] font-semibold mb-4">
            Our Branches
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-semibold text-white">
            Two locations in Noida.
            <br />
            <span className="text-white/40">One promise of focus.</span>
          </h2>
          <p className="mt-5 text-white/55 text-sm md:text-base max-w-xl leading-relaxed">
            Best <strong className="text-white/90">study library in Sector 22 Noida</strong> (open
            24/7) and a peaceful <strong className="text-white/90">reading room in Sector 26 Noida</strong>{" "}
            (8 AM – 10 PM). Pick the branch closest to you and reserve your seat.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <BranchCard b={BRANCHES.s22} idx={1} />
          <BranchCard b={BRANCHES.s26} idx={2} />
        </div>
      </div>
    </section>
  );
}
